/*
  ButtonBase.jsx
*/

// Npm.
import React, { useMemo } from 'react';

// Makes.
import { makeStyles, cx } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    '&.btn': {
      letterSpacing: '0.05em',  // Buttons have less letter spacing for some reason.
    },
    margin: 0,
    padding: 0,
    textAlign: 'inherit',
    display: 'inline-flex',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    outline: 'none',
    border: 'none',
    transition: 'background-color 0.1s ease',
    '&:hover': {
      backgroundColor: theme.action_hover,
    },
    '&:focus-visible': {
      backgroundColor: theme.action_hover,
    },
    '&:disabled': {
      cursor: 'inherit',
      color: theme.color_text_disabled,
      backgroundColor: 'transparent',
    },
    '&.fullWidth': {
      minWidth: 0,
      width: '100%',
    },
  },
}));

/**
 * Renders a simple button, but without the padding or borders.
 * Has no typography properties.
 */
export default function ButtonBase({ className, component = 'button', size, color, fullWidth, ...rest }) {

  let rootClass = 'Button';

  if (component === 'button') {
    rootClass += ' btn';
  }

  if (size === 'small') {
    rootClass += ' small';
  }

  if (fullWidth) {
    rootClass += ' fullWidth';
  }

  // TODO: Use color prop.

  const classes = useStyles();
  const cls = useMemo(() => cx(rootClass, classes.root, className), [rootClass, classes.root, className]);

  const Component = component;

  return (
    <Component
      type="button"
      className={cls}
      {...rest}
    />
  );
}
